import { HttpClient } from "@angular/common/http";
import { MediaHubPagingParameters } from "../../contracts/media-hub/MediaHubPagingParameters";
import { Globals } from "projects/shared/models/Globals";
import { Injectable } from "@angular/core";

@Injectable()
export class MediaHubService {
  constructor(private http: HttpClient) {}
  GetMediaHubsPage(input: MediaHubPagingParameters) {
    return this.http.post(
      `${Globals.BaseUrl}/MediaHubWebAPI/GetMediaHubPage`,
      input
    );
  }
}
